import React from "react";
import { useState } from "react";
import "components/generales/Styles.css";
import Navbar from "components/generales/Navbar";
import RegistroEtiquetas from "components/etiquetas/RegistroEtiquetas";
import "components/etiquetas/StylesEtiquetas.css";

const RegistrarEtiquetas = ({ etiqueta }) => {
  const [registroEtiquetas, setRegistroEtiquetas] = useState([]);

  return (
    <>
      <Navbar />
      <section>
        <div className="imagenContenedor imagenEtiquetas"></div>
        <div className="contenidoContenedor">
          <div className="formularioContenedor">
            <h2>Registro de Etiquetas</h2>
            <RegistroEtiquetas
              registroEtiquetas={registroEtiquetas}
              setRegistroEtiquetas={setRegistroEtiquetas}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default RegistrarEtiquetas;
